import fitSvgTextNode from "../../utilities/fit-svg-text-node";
import stringToHTML from "../../utilities/string-to-html";
/**
 * Creates an SVG based label that will fit the label text given within the
 * width given. It will return the SVG as a data URL so it can be used with
 * a Google Marker image if you wanted.
 *
 * @param {string} text The text to fit within the label
 * @param {number} width The width of the label
 * @param {number} height The height of the label
 *
 * @return {string} An SVG data URI
 */
export default function createSvgLabel(_a) {
    var text = _a.text, _b = _a.width, width = _b === void 0 ? 150 : _b, _c = _a.height, height = _c === void 0 ? 40 : _c;
    var tempSvg = "\n\t\t\t\t<svg width=\"".concat(width, "px\" height=\"").concat(height, "px\" viewBox=\"0 0 ").concat(width, " ").concat(height, "\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t\t\t\t<rect width=\"100%\" height=\"100%\" fill=\"#4285F4\"></rect>\n\t\t\t\t\t<text style=\"font-family:Arial, sans-serif;\" fill=\"#fff\" x=\"50%\" y=\"50%\" font-size=\"10px\" dominant-baseline=\"central\" text-anchor=\"middle\">\n\t\t\t\t\t\t").concat(text, "\n\t\t\t\t\t</text>\n\t\t\t\t</svg>\n\t\t\t");
    var svg = stringToHTML(tempSvg);
    document.body.appendChild(svg);
    fitSvgTextNode(svg.querySelector("text"));
    document.body.removeChild(svg);
    return "data:image/svg+xml," + encodeURIComponent(svg.outerHTML);
}
